export default "__VITE_ASSET__tCIuUmXr__"